import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  INVOICE_SHOW_ERROR,
  INVOICE_SHOW_LOADING,
  INVOICE_SHOW_RETRIEVED_SUCCESS,
  INVOICE_SHOW_RESET
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  retrieved: null
};

function error(error) {
  return {type: INVOICE_SHOW_ERROR, error};
}

function loading(loading) {
  return {type: INVOICE_SHOW_LOADING, loading};
}

function retrieved(retrieved) {
  return {type: INVOICE_SHOW_RETRIEVED_SUCCESS, retrieved};
}

function reset() {
  return {type: INVOICE_SHOW_RESET};
}

const getters = {
  error: state => state.error,
  loading: state => state.loading,
  item: state => state.retrieved
};

const actions = {
  retrieve({ commit }, id) {
    commit(loading(true));
    commit(error(null));
   return http.fetch('/invoices/' + id)
      .then(response => response.json())
      .then(data => {
        commit(loading(false));
        commit(retrieved(data));
      })
      .catch(e => {
        commit(loading(false));
        if(security.handleAuthorizationError(e)){
          return;
        }
        commit(error(e.message));
      });
  },
  reset({ commit }) {
    commit(reset());
  }
};

const mutations = {
    [INVOICE_SHOW_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [INVOICE_SHOW_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [INVOICE_SHOW_RETRIEVED_SUCCESS] (state, payload) {
      state.retrieved = payload.retrieved;
    },
    [INVOICE_SHOW_RESET] (state) {
      state.retrieved = null;
      state.error = '';
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/invoice/show.js